<template>
	<div class="pui-form">
		<mtipytamequipamiento-modals :modelName="modelName"></mtipytamequipamiento-modals>
		<!--<pui-form-header
			v-if="modelLoaded"
			:showHeader="!isCreatingElement">
			<mtipytamequipamiento-form-header
				:modelPk="modelPk"
			></mtipytamequipamiento-form-header>
		</pui-form-header>-->
		<v-form class="mb-4 pb-4" ref="form" v-model="valid" lazy-validation @submit.prevent v-if="modelLoaded">
			<v-layout wrap class="pui-form-layout">
				<v-flex xs12 md12>
					<pui-field-set :title="getTitleDatos">
						<v-layout wrap>
							<!-- IDTIPTAM -->
							<v-flex xs12 md1>
								<pui-text-field
									:id="`idtiptam-mtipytamequipamiento`"
									v-model="model.idtiptam"
									:label="$t('mtipytamequipamiento.idtiptam')"
									disabled
									toplabel
									maxlength="10"
								></pui-text-field>
							</v-flex>
							<!-- CODTIPTAMEDI -->
							<v-flex xs12 md1>
								<pui-text-field
									:id="`codtiptamedi-mtipytamequipamiento`"
									v-model="model.codtiptamedi"
									:label="$t('mtipytamequipamiento.codtiptamedi')"
									:disabled="formDisabled"
									toplabel
									maxlength="10"
								></pui-text-field>
							</v-flex>
						</v-layout>
						<v-layout wrap>
							<!-- NAME -->
							<v-flex xs12 md4>
								<pui-text-field
									:id="`name-mtipytamequipamiento`"
									v-model="model.name"
									:label="$t('mtipytamequipamiento.name')"
									:disabled="formDisabled"
									required
									toplabel
									maxlength="100"
								></pui-text-field>
							</v-flex>
						</v-layout>
						<v-layout wrap>
							<!-- FECBAJA -->
							<v-flex xs12 md3>
								<pui-date-field
									:id="`fecbaja-mtipytamequipamiento`"
									v-model="model.fecbaja"
									:label="$t('mtipytamequipamiento.fecbaja')"
									:disabled="formDisabled"
									toplabel
									time
								></pui-date-field>
							</v-flex>
						</v-layout>
						<!-- MINI AUDIT -->
						<pui-form-mini-audit class="pl-2" :model="model" v-if="!isCreatingElement"></pui-form-mini-audit>
					</pui-field-set>
				</v-flex>
			</v-layout>

			<!-- Page Footer -->
			<pui-form-footer v-if="!isModalDialog">
				<pui-form-footer-btns
					:formDisabled="formDisabled"
					:saveDisabled="saving"
					:saveAndNew="saveAndNew"
					:saveAndUpdate="saveAndUpdate"
					:save="save"
					:back="back"
				></pui-form-footer-btns>
			</pui-form-footer>
		</v-form>
		<pui-form-loading v-else></pui-form-loading>
	</div>
</template>

<script>
import {PuiFormMethodsMixin} from '@Pui9Components';
import mtipytamequipamientoActions from './MtipytamequipamientoActions';
import mtipytamequipamientoModals from './MtipytamequipamientoModals.vue';

export default {
	name: 'mtipytamequipamiento-form',
	mixins: [PuiFormMethodsMixin],
	components: {
		'mtipytamequipamiento-modals': mtipytamequipamientoModals
	},
	data() {
		return {
			modelName: 'mtipytamequipamiento',
			actions: mtipytamequipamientoActions.formActions
		};
	},
	methods: {
		afterGetData() {
			// Do something after get data from server
		}
	},
	computed: {
		getTitleDatos() {
			return this.$t('form.mtipytamequipamiento');
		}
	},
	created() {}
};
</script>
